import { render, staticRenderFns } from "./mealReview.vue?vue&type=template&id=f37ee4a6&scoped=true&"
import script from "./mealReview.vue?vue&type=script&lang=js&"
export * from "./mealReview.vue?vue&type=script&lang=js&"
import style0 from "./mealReview.vue?vue&type=style&index=0&id=f37ee4a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37ee4a6",
  null
  
)

export default component.exports